import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./SuccessMessageStyles";

export default class SuccessMessage extends Component {
  render() {
    return (
      <div className={css(styles.bannerWrapper)}>
        <span className={css(styles.banner)}>{this.props.message}</span>
      </div>
    );
  }
}
